// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3SFJi","actions":"GroupTable_actions__2l0tw","deleteModalFooter":"GroupTable_deleteModalFooter__38T-D"};